import axiosInstance from './axios.service';

const CRM_V1 = '/crm/v1';

export const createProposal = (payload) => axiosInstance.post(`${CRM_V1}/proposals`, payload);
export const getProposal = (id) => axiosInstance.get(`${CRM_V1}/proposals/${id}`);
export const updateProposal = (id, payload) => axiosInstance.patch(`${CRM_V1}/proposals/${id}`, payload);
export const deleteProposal = (id) => axiosInstance.delete(`${CRM_V1}/proposals/${id}`);
export const listProposals = (params = {}) => axiosInstance.post(`${CRM_V1}/proposals/list`, params);
